import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const EXTERNES_ROUTES: Routes = [
  {
    path: 'externes/list',
    loadComponent: () => import('../features/externes/list/list.component').then(m => m.ExternesListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD],
    },
  },
  {
    path: 'externes/add',
    loadComponent: () => import('../features/externes/add/add.component').then(m => m.ExternesAddComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD],
    },
  },
  {
    path: 'externes/edit/:id',
    loadComponent: () => import('../features/externes/edit/edit.component').then(m => m.ExternesEditComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD],
    },
  },
  {
    path: 'externes/disponibilites',
    loadComponent: () =>
      import('../features/externes/disponibilites/disponibilites.component').then(m => m.DisponibilitesComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.PODOLOGUE, ROLES.COIFFEUR],
    },
  },
];
